import { createContext } from 'react';
import config from './../config.json';

export const apiContext = createContext(config);